import { checkFont } from '@common/components/func';
import { IMultiRadioButton } from '@common/types/element';
import { isEmpty, pick } from 'lodash';
import { Platform, StyleSheet } from 'react-native';

const createStyles = (attributes: IMultiRadioButton) => {
  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'borderColor',
        'borderRadius',
        'backgroundColor',
        'opacity',
      ]),

      shadowColor: attributes?.shadow?.color || '#fff',
      shadowRadius: attributes?.shadow?.size || 0,
      shadowOpacity: attributes?.shadow?.blur || 0,
      shadowOffset: {
        width: attributes?.shadow?.x || 0,
        height: attributes?.shadow?.y || 0,
      },
      elevation: attributes?.shadow?.size || 0,
      ...(!isEmpty(attributes.borderStyle) && {
        borderStyle:
          attributes.borderStyle === 'none' ? 'solid' : attributes.borderStyle,
      }),
    },
    radioItem: {
      marginVertical: 2,
    },
    radioContent: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 8,
      paddingHorizontal: 4,
    },
    radioText: {
      marginLeft: 8,
      fontSize: attributes.fontSize,
      color: attributes.color,
      flex: 1,
      ...(Platform.OS !== 'web' && {
        fontFamily: checkFont(attributes?.fontFamily),
      }),
      lineHeight:
        Platform.OS === 'web' ? undefined : attributes.fontSize * 1.15,
    },
    radioTextSelected: {
      fontWeight: '600',
    },
    headerContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginBottom: 12,
    },
    clearButton: {
      paddingHorizontal: 8,
      paddingVertical: 4,
    },
    clearButtonText: {
      fontSize: attributes.fontSize * 0.9,
      color: attributes.color,
      textDecorationLine: 'underline',
    },
    deselectInfoText: {
      fontSize: attributes.fontSize * 0.8,
      color: attributes.color,
      opacity: 0.6,
      textAlign: 'center',
      marginTop: 8,
      fontStyle: 'italic',
    },
    loadMoreContainer: {
      padding: 16,
      alignItems: 'center',
    },
  });
};

export default createStyles;
